import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcClock(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.75 11.696V7.75a.73.73 0 0 0-.216-.534A.73.73 0 0 0 12 7a.73.73 0 0 0-.535.216.73.73 0 0 0-.215.534v4.177q0 .177.065.342a.9.9 0 0 0 .206.306L14.946 16q.208.209.522.212A.7.7 0 0 0 16 16a.72.72 0 0 0 .217-.527.72.72 0 0 0-.217-.527z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25M3.75 12a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0",
    clipRule: "evenodd"
  }));
}
var IcClock = createNolIcon(/*#__PURE__*/forwardRef(SvgIcClock));

export { IcClock as I };
